import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { Processo } from 'app/interfaces/processo';
import { ProcessoCancelar } from 'app/interfaces/processo-cancelar';
import { ProcessoFiltro } from 'app/interfaces/processo-filtro';
import { ProcessoInfoParaBuscarTarifario } from 'app/interfaces/processo-info-para-buscar-tarifario';
import { ProcessoLucratividade } from 'app/interfaces/processo-lucratividade';
import { ProcessoResumoCusto } from 'app/interfaces/processo-resumo-custo';
import { ProcessoUpdateAbaCarga } from 'app/interfaces/processo-update-aba-carga';
import { ProcessoUpdateAbaDetalhes } from 'app/interfaces/processo-update-aba-detalhes';
import { ProcessoUpdateAbaDocumental } from 'app/interfaces/processo-update-aba-documental';
import { ProcessoUpdateAbaEmbarque } from 'app/interfaces/processo-update-aba-embarque';
import { ProcessoUpdateAbaObservacoes } from 'app/interfaces/processo-update-aba-observacoes';
import { ProcessoUpdateAbas } from 'app/interfaces/processo-update-abas';
import { ProcessoUpdateCourier } from 'app/interfaces/processo-update-courier';
import { environment } from 'environments/environment';
import { TimezoneService } from 'app/utils/timezone.service';
import { ProcessoInvoiceFaturaCreate } from 'app/interfaces/processo-invoice-fatura-create';
import { ProcessoConsolidadoReferencia } from 'app/interfaces/processo-consolidado-referencia';
import { ProcessoDataFaturamento } from 'app/interfaces/processo-data-faturamento';
import { TeusCalculo } from 'app/interfaces/teusCalculo';
import { ProcessoControleBooking } from 'app/interfaces/processo-controle-booking';
import { ProcessoVolume } from 'app/interfaces/processo-volume';
import { ProcessoEquipamento } from 'app/interfaces/processo-equipamento';
import { ProcessoAuditoriaFinal } from 'app/interfaces/processo-auditoria-final';
import { HomeProcessoVendedor } from 'app/interfaces/home-processo-vendedor';
import { SiscomexConhecimentoCargaAereaHAWB } from 'app/interfaces/enum/siscomex-conhecimento-carga-aerea-hawb';
import { StatusCCT } from 'app/interfaces/enum/status-cct';

@Injectable({
  providedIn: 'root',
})
export class ProcessoHttpService {
  constructor(private _http: HttpClient, private _timezoneService: TimezoneService) {}

  /**
   * Função para buscar todos 1processos;
   * @param nome
   * @param page
   * @returns
   */
  getAll({ filtro, size = 200, page = 0, sort = '' }: { filtro: ProcessoFiltro; size?: number; page?: number; sort?: string }) {
    return this._http.post<Pageable>(`${environment.apiUrl}/api/process/v1/processos?sort=${sort}&size=${size}&page=${page}`, filtro);
  }

  /**
   * Função para buscar o processo pelo id;
   * @param id
   * @returns
   */
  getById(id: number) {
    return this._http.get<Processo>(`${environment.apiUrl}/api/process/v1/processos/${id}`);
  }

  /**
   * Função para buscar o header do processo pelo id;
   * @param id
   * @returns
   */
  getHeaderById(id: number) {
    return this._http.get<Processo>(`${environment.apiUrl}/api/process/v1/processos/header/${id}`);
  }

  /**
   * Função para salvar um processo;
   * @param processo
   * @returns
   */
  salvar(processo: Processo) {
    return this._http.post<Processo>(`${environment.apiUrl}/api/process/v1/processos`, processo);
  }

  /**
   * Função para atualizar um processo;
   * @param processo
   * @returns
   */
    updateGrupos(processoId: number, processoUpdateAbas: ProcessoUpdateAbas, atualizarCustos: boolean) {
    return this._http.put<boolean>(
      `${environment.apiUrl}/api/process/v1/processos/${processoId}?atualizarCustos=${atualizarCustos}`,
      processoUpdateAbas
    );
  }

  updateHeader(processo: Processo) {
    return this._http.put<Processo>(`${environment.apiUrl}/api/process/v1/processos/header/${processo.processoId}`, processo);
  }

  /**
   * Delete um registro;
   * @param id
   * @returns
   */
  delete(id: number) {
    return this._http.delete<boolean>(`${environment.apiUrl}/api/process/v1/processos/${id}`);
  }

  /**
   * Atualizar resumo de custos
   * @param processoResumoCusto
   */
  updateResumoCustosByProcessoId(processoId: number, validaSeguro: boolean) {
    return this._http.put<ProcessoResumoCusto>(
      `${environment.apiUrl}/api/process/v1/processos/resumo-custos-by-processo-id/${processoId}?validaSeguro=${validaSeguro}`,
      null
    );
  }

  /**
   * Função para validar Campos dos Custos pelo id do processo;
   * @param processoId
   * @returns
   */
  validaCamposCustosByProcessoId(processoId: number) {
    return this._http.get<boolean>(`${environment.apiUrl}/api/process/v1/processos/valida-campos-custos-by-processo/${processoId}`);
  }

  /**
   * Função para buscar o resumo dos custos pelo id do processo;
   * @param processoId
   * @returns
   */
  getResumoCustosByProcessoId(processoId: number) {
    return this._http.get<ProcessoResumoCusto>(`${environment.apiUrl}/api/process/v1/processos/resumo-custos/${processoId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoId
   */
  getAbaDetalhes(processoId: number) {
    return this._http.get<ProcessoUpdateAbaDetalhes>(`${environment.apiUrl}/api/process/v1/processos/detalhes/${processoId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoId
   */
  getAbaCarga(processoId: number) {
    return this._http.get<ProcessoUpdateAbaCarga>(`${environment.apiUrl}/api/process/v1/processos/carga/${processoId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoId
   */
  getAbaEmbarque(processoId: number) {
    return this._http.get<ProcessoUpdateAbaEmbarque>(`${environment.apiUrl}/api/process/v1/processos/embarque/${processoId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoId
   */
  getAbaDocumental(processoId: number) {
    return this._http.get<ProcessoUpdateAbaDocumental>(`${environment.apiUrl}/api/process/v1/processos/documental/${processoId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoId
   */
  getAbaObservacoes(processoId: number) {
    return this._http.get<ProcessoUpdateAbaObservacoes>(`${environment.apiUrl}/api/process/v1/processos/observacoes/${processoId}`);
  }

  /**
   * Função para pegar informações para incluir no tarifário
   * @param processoId
   */
  getInformacoesParaIncluirTarifario(processoId: number) {
    return this._http.get<ProcessoInfoParaBuscarTarifario>(`${environment.apiUrl}/api/process/v1/processos/informacoes-tarifario/${processoId}`);
  }

  updateCourierByProcessosIds(processoUpdateCourier: ProcessoUpdateCourier) {
    return this._http.put<Processo>(`${environment.apiUrl}/api/process/v1/processos/update-courier`, processoUpdateCourier);
  }

  /**
   * Função para pegar informações para incluir no tarifário
   * @param processoId
   */
  getProcessosAndCouriersFlat(codigoProcesso: string, numeroCourier: string, house: string, master: string) {
    const params = {
      codigoProcesso: codigoProcesso,
      numeroCourier: numeroCourier,
      house: house,
      master: master,
    };
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/processos/processo-couriers-flat`, { params });
  }

  getAllAudit(processoId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/processos-auditorias/${processoId}`, { params: params });
  }

  /**
   * @param parceiroClienteId
   * @returns
   */
  atualizaAllContatosProcesso(processoId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process/v1/processos/atualiza-all-contatos-by-parceiro/${processoId}`, null);
  }

  findProcessosByCodigo(codigoProcesso: string) {
    return this._http.get<Processo[]>(`${environment.apiUrl}/api/process/v1/processos/find-processos-by-codigo?codigoProcesso=${codigoProcesso}`);
  }

  findNrSpotContratoByProcessoId(processoId: number) {
    return this._http.get<Processo>(`${environment.apiUrl}/api/process/v1/processos/find-nrspot-contrato-by-processoid/${processoId}`);
  }

  findAgenteCiaAereaByProcessoId(processoId: number) {
    return this._http.get<any>(`${environment.apiUrl}/api/process/v1/processos/find-agente-ciaArea-by-processoid/${processoId}`);
  }

  salvaNCMsProcesso(ncms: string, processoId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process/v1/processos/salvar-ncms-processo/${processoId}?ncms=${ncms}`, null);
  }

  cancelar(justificativa: ProcessoCancelar) {
    return this._http.post<boolean>(`${environment.apiUrl}/api/process/v1/processos/cancelar`, justificativa);
  }

  getInformacaoGraficoLucratividade(processoId: number,dataInicial?: string,
  dataFinal?: string) {
  let params: any = {};

  if (dataInicial && dataFinal) {
    params.dataInicial = dataInicial;
    params.dataFinal = dataFinal;
  }
    return this._http.get<ProcessoLucratividade[]>(`${environment.apiUrl}/api/process/v1/processo-historico-lucratividade/${processoId}`,{ params });
  }

  getAuditComparacao(processoId: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/processos-auditorias/comparacao-audit/${processoId}?rev=${rev}`);
  }

  /**
   * Busca informações do processo para montagem de uma nova invoice;
   * @param processoId
   * @returns
   */
  getProcessoMontaInvoice(processoId: number) {
    return this._http.get<ProcessoInvoiceFaturaCreate>(`${environment.apiUrl}/api/process/v1/processos/get-processo-monta-invoice/${processoId}`);
  }

  /**
   * Busca processos disponíveis para consolidação
   * @param parceiroCiaAereoId
   * @param origemEmbarqueId
   * @param destinoDesembarqueId
   * @returns
   */
  getProcessosParaConsolidar(parceiroCiaAereoId: number, origemEmbarqueId: number, destinoDesembarqueId: number) {
    const params = {
      parceiroCiaAereoId: parceiroCiaAereoId || '',
      origemEmbarqueId: origemEmbarqueId || '',
      destinoDesembarqueId: destinoDesembarqueId || '',
    };
    return this._http.get<ProcessoConsolidadoReferencia[]>(`${environment.apiUrl}/api/process/v1/processos/lista-processo-consolidado-referencia`, {
      params,
    });
  }

  /**
   *
   */
  getDataFaturamentoProcesso(processoId: number) {
    return this._http.get<ProcessoDataFaturamento>(`${environment.apiUrl}/api/process/v1/processos/get-processo-data-faturamento/${processoId}`);
  }

  getTeus(teus: TeusCalculo[]) {
    return this._http.post<number>(`${environment.apiUrl}/api/process/v1/oportunidade-oferta-equipamentos/get-teus`, teus);
  }

  findProcessosByCodigoControleBooking(codigoProcesso: string) {
    return this._http.get<ProcessoControleBooking[]>(
      `${environment.apiUrl}/api/process/v1/processos/find-processos-by-codigo-controle-booking?codigoProcesso=${codigoProcesso}`
    );
  }

  getResultadoCalculoCubagem(volume: ProcessoVolume) {
    return this._http.post<ProcessoVolume>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/calcular-cubagem`, volume);
  }

  updateEquipamento(equipamentoId: number, equipamento: ProcessoEquipamento) {
    return this._http.put<ProcessoEquipamento>(`${environment.apiUrl}/api/process/v1/processo-equipamentos/${equipamentoId}`, equipamento);
  }

  existsProcessoDemurrage(processoReferenciaId: number) {
    return this._http.get<boolean>(`${environment.apiUrl}/api/process/v1/processos/demurrage-exists/${processoReferenciaId}`);
  }

  getAuditoriaFinal(processoId: number) {
    return this._http.get<ProcessoAuditoriaFinal>(`${environment.apiUrl}/api/process/v1/processos/processo-auditoria-final/${processoId}`);
  }

  updateAuditoriaFinal(processoAuditoriaFinal: ProcessoAuditoriaFinal) {
    return this._http.post<ProcessoAuditoriaFinal>(
      `${environment.apiUrl}/api/process/v1/processos/processo-auditoria-final/${processoAuditoriaFinal.processoId}`,
      processoAuditoriaFinal
    );
  }

  getInformacaoGraficoProcessoVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    const params: any = { vendedorId };

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<HomeProcessoVendedor[]>(`${environment.apiUrl}/api/process/v1/processos/resumo-processos-by-vendedor`, { params });
  }

  getTotaisDemurrage(equipamentos: ProcessoEquipamento[]) {
    return this._http.post<ProcessoEquipamento>(
      `${environment.apiUrl}/api/process/v1/processo-custos/demurrage-totais`,
      equipamentos
    );
  }

  getAllProcessosParaConsolidar(page: number = 0, sort?: string, codigoProcesso?: string, ciaAereaId?: number) {
    const params = {
      size: 10,
      page: page || '',
      sort: sort || '',
      codigoProcesso: codigoProcesso || '',
      ciaAereaId: ciaAereaId || '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/processos/find-all-para-consolidar`, { params });
  }

  consolidarProcessos(parceiroNegocioCompanhiaAereaEstoqueId: number, processos: Processo[]) {
    const procesosParaConsolidar = Array.from(processos
      .map(p => { return { codigoProcesso: p.codigoProcesso, processoId: p.processoId }}));

    return this._http.put<Boolean>(`${environment.apiUrl}/api/process/v1/processos/consolidar?parceiroNegocioCompanhiaAereaEstoqueId=${parceiroNegocioCompanhiaAereaEstoqueId}`
      , procesosParaConsolidar);
  }

  verificaFaturaDemurrageQuitada(processoId: number) {
    return this._http.get<Boolean>(`${environment.apiUrl}/api/financial/v1/faturas/verifica-fatura-demurrage-quitada?processoId=${processoId}`
    );
  }

  /**
   * Busca a lista de revisões de auditoria para os volumes de um processo
   */
  getAllAuditVolumeByProcesso(processoId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/processo-volumes-auditorias/${processoId}`, { params: params });
  }

  /**
   * Busca a comparação de uma revisão específica de um volume
   */
  getVolumeAuditComparacao(processoVolumeId: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/processo-volumes-auditorias/comparacao-audit/${processoVolumeId}?rev=${rev}`);
  }

  getAllAuditEquipamentoByProcesso(processoId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/processo-equipamentos-auditorias/${processoId}`, { params: params });
  }

  getEquipamentoAuditComparacao(id: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/processo-equipamentos-auditorias/comparacao-audit/${id}?rev=${rev}`);
  }

  getAllAuditCustoDemurrageByProcesso(processoId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/processo-tarifario-demurrage-custo-auditorias/${processoId}`, { params: params });
  }

  getCustoDemurrageAuditComparacao(id: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/processo-tarifario-demurrage-custo-auditorias/comparacao-audit/${id}?rev=${rev}`);
  }

  getSiscomexConhecimentosCargaAerea(master: string) {
    return this._http.get<SiscomexConhecimentoCargaAereaHAWB[]>(`${environment.apiUrl}/api/process/v1/siscomex-api/conhecimento-carga-aerea/${master}`);
  }

  getCodigoProcessoByHouse(house: string) {
    return this._http.get<string[]>(`${environment.apiUrl}/api/process/v1/processos/codigo-processo-by-house/${house}`);
  }

  isTarifarioDentroFaixaPeso(processo: {
    processoId: number; produto: string; pesoTaxadoVolumes: number;
    destinoDesembarqueId: number; destinoCargaId: number;
  }) {
    return this._http.post<boolean>(
      `${environment.apiUrl}/api/process/v1/processos/verificar-faixa-peso-tarifario`, processo
    );
  }


  integrarProcessoComoHouse(house: string, processoId: number, recintoAlfandegadoId: number) {
    let params = {
      house,
      recintoAlfandegadoId
    };

    return this._http.put<Processo>(`${environment.apiUrl}/api/process/v1/siscomex-api/integrar-processo-como-house/${processoId}`, null, {
      params
    });
  }

  removerProcessoComoHouse(house: string, processoId: number) {
    let params = {
      house
    };

    return this._http.delete<Processo>(`${environment.apiUrl}/api/process/v1/siscomex-api/remover-processo-como-house/${processoId}`, {
      params
    });
  }

  getProcessoIntegracaoStatus(processoId: number) {
    return this._http.get<StatusCCT>(`${environment.apiUrl}/api/process/v1/siscomex-api/integracao-status/${processoId}`);
  }
}
